$(document).ready(function() {
  $(document).on('change', "#select_checklist", function (e) {
    var checklist_id = e.target.value
    $.ajax({
      type: 'GET',
      dataType: 'script',
      url: `/task_checklists/${checklist_id}/import_tasks`,
      success: function (response) {
      }
    })
  });

  $(document).on('click', '#import_task_button', function () {
    var constainer = $('.task_item_row')
    var data_container = []
    constainer.each(function () {
      var id = $(this).data("id")
      var input_value = $(this).find("input").val()
      var task_type = $(this).find("select").val()
      data_container.push({ id: id, input_value: input_value, task_type: task_type })
    })

    $.ajax({
      type: 'GET',
      dataType: 'script',
      url: `/work_orders/import_tasks`,
      data: { data_container },
      success: function (response) {
      }
    })
  })
  $(document).on('click', '#remove_task_item', function () {
    $(this).parent().remove();
  })

  /*For parts edit */
  $(document).on('change', "#select_part", function (e) {
    var part_id = e.target.value
    $.ajax({
      type: 'GET',
      dataType: 'script',
      url: `/parts/${part_id}`,
      success: function (response) {
      }
    })
  });

  $(document).on('change', "#work_order_primary_asset_id", function (e)
  {
    var assetID = $(this).val()
    console.log(assetID)
    $.ajax({
    type: 'GET',
    dataType: 'json',
    url: `/api/v1/checklists`,
    data: { asset_id: assetID },
    success: function(response) {

      console.log("response");
      console.log(response);
      // var checklistIds = response.data.map(item => { return item.id;});
      const checklistIds = response.data.flatMap(item =>
        item.checklist_revisions
          ?.filter(rev => rev.status === 'active')
          .map(rev => rev.id) || []
      );

      console.log(checklistIds)
      $(`#work_order_checklist_version_ids`).val(checklistIds).trigger('change');
    },
    error: function(error){console.log(error)}
    });
  })

  $(document).on('click', "#import_part_button", function (e) {
    var constainer = $('.part_item_row')
    var data_container = []
    constainer.each(function () {
      var id = $(this).find("#part_id").val()
      var part_title = $(this).find("#part_title").val()
      var quantity = $(this).find("#quantity").val()
      data_container.push({ id: id, part_title: part_title, quantity: quantity });

      $.ajax({
        type: 'GET',
        dataType: 'script',
        url: `/work_orders/import_parts`,
        data: { data_container },
        success: function (response) {
          $('#parts_container').html("")
        }
      })
    });
  })
  // $(document).on('change', ".work-order-task-input, .work-order-task-select", function (e) {
  //   alert("Input cjanged")
  //   $('#work_order_tasks_form').submit();
  // });
  $(document).on('change', '.small_number_field', function (e) {
    var max_data = $(this).data('max');
    if (e.target.value > max_data) {
      $(this).val(max_data)
    }
    if (e.target.value < 0) {
      $(this).val(0)
    }
  })

  $(document).on('click', '.addbtn', function () {
    var parent_el = $(this).parent();
    var quantity = parent_el.find("#quantity").val();
    var store_id = parent_el.find("#store_id").val();
    var part_id = $("#part_id").val();
    var part_title = $("#part_name").val();
    var flag = false;
    var quantity_flag = quantity > 0
    $('.check_for_existing_part').each(function () {
      if ($(this).data('part') == part_id && $(this).data('store') == store_id) {
        M.toast({ html: 'It is already exists.' })
        flag = true;
        return;
      }
    });
    if (quantity_flag) {
      if (!flag) {
        var data_container = []
        data_container.push({ id: part_id, store_id: store_id, part_title: part_title, quantity: quantity });
        $.ajax({
          type: 'GET',
          dataType: 'script',
          url: `/work_orders/import_parts`,
          data: { data_container },
          success: function (response) {
            M.toast({ html: 'Part added successfully' })
            parent_el.parent().remove();
          },
          error: function (res) {
            M.toast({ html: 'Something went worng!!' })
          }
        });
      }
    } else {
      M.toast({ html: 'Quantity must be greater than zero' })
    }
  });

})